<template>
  <AdminLayout spacing="p-0">
    <Head title="Homestead - May 16, 22 @12:00pm" />

    <div class="flex -my-4">
      <div class="w-3/4 relative">
        <div
          id="count-header"
          class="bg-gray-400 p-12 sticky top-0 z-10"
        >
          <h1 class="text-blue-600 font-semibold text-2xl">Homestead - May 16, 2022</h1>

          <div class="flex text-gray-600 items-center my-2 text-sm gap-3">
            <span class="flex items-center gap-1">
              <CalendarIcon
                class="h-4 w-4 text-gray-600"
                aria-hidden="true"
              />
              May, 16, 2022
            </span>
            <span class="flex items-center gap-1">
              <ClockIcon
                class="h-4 w-4 text-gray-600"
                aria-hidden="true"
              />
              12:00 PM
            </span>
            <span class="flex items-center gap-1">
              <LocationMarkerIcon
                class="h-4 w-4 text-gray-600"
                aria-hidden="true"
              />
              Homestead
            </span>
            <span class="flex items-center gap-1">
              <TagIcon
                class="h-4 w-4 text-gray-600"
                aria-hidden="true"
              />
              Damaged
            </span>
          </div>

          <div class="input-group relative flex justify-between items-center mt-5">
            <div class="flex gap-3 w-3/4">
              <div class="relative flex items-stretch grow focus-within:z-10">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SearchIcon
                    class="h-4 w-4 text-blue-600"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search Products"
                  class="pl-9"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Qty"
                  class="w-32"
                />
              </div>
              <button
                @click="openCreate()"
                type="button"
                class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm bg-gray-500 text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
              >
                Count
              </button>
            </div>

            <!-- FINAL BUTTON -->
            <!-- <div class="flex items-center gap-5">
                            <a href="#" class="text-gray-600 text-sm">Cancel</a>
                            <button @click="openCreate()" type="button" class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-red-600 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600">
                                Final
                            </button>
                        </div> -->

            <!-- REVIEW BUTTON -->
            <div class="flex items-center gap-5">
              <button
                @click="openCreate()"
                type="button"
                class="inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
              >
                Review
              </button>
            </div>
          </div>
        </div>

        <div
          id="count-alert"
          class="relative flex bg-red-600 left-0 right-0 w-full p-3 items-center"
        >
          <ExclamationCircleIcon
            class="h-7 w-7 mr-5 text-gray-100"
            aria-hidden="true"
          />
          <span class="text-gray-100 leading-snug block text-xs font-semibold"
            >WARNING! The items highlighted below don’t match expected. Please recount before submitting for a final
            time.</span
          >
        </div>

        <div
          id="count-product"
          class="p-12"
        >
          <data-table
            :items="data"
            :headers="headers"
            :actions="[]"
            :selectable="false"
          >
            <template v-slot:rows="slotRow">
              <count-row
                v-slot:rows="slotRow"
                v-bind="slotRow"
                :class="{ active: selected }"
                @click="selected = !selected"
              />
            </template>
          </data-table>
        </div>
      </div>

      <div class="list bg-gray-100 min-h-screen w-1/4">
        <div class="sticky top-0 z-10 overflow-y-auto">
          <h2 class="text-base font-semibold py-3 px-5 border-b border-gray-400">Last Counted</h2>
          <div
            id="count-items"
            class="w-full divide-y divide-gray-400"
          >
            <!-- ITEM -->
            <div class="item flex justify-between items-center py-3 px-5">
              <div class="flex items-center">
                <span class="count text-gray-600">20</span>
                <div class="flex flex-col leading-tight px-5">
                  <span class="text-blue-600 font-semibold text-sm">777 OG Eight</span>
                  <small class="text-gray-600">777-og-eighth</small>
                </div>
              </div>
              <a
                @click="openRemove()"
                class="text-gray-600 cursor-pointer"
                ><MinusCircleIcon
                  class="h-5 w-5 text-gray-600"
                  aria-hidden="true"
              /></a>
            </div>
            <!-- ITEM -->

            <!-- ITEM -->
            <div class="item flex justify-between items-center py-3 px-5">
              <div class="flex items-center">
                <span class="count text-gray-600">20</span>
                <div class="flex flex-col leading-tight px-5">
                  <span class="text-blue-600 font-semibold text-sm">777 OG Eight</span>
                  <small class="text-gray-600">777-og-eighth</small>
                </div>
              </div>
              <a
                @click="openRemove()"
                class="text-gray-600 cursor-pointer"
                ><MinusCircleIcon
                  class="h-5 w-5 text-gray-600"
                  aria-hidden="true"
              /></a>
            </div>
            <!-- ITEM -->

            <!-- ITEM -->
            <div class="item flex justify-between items-center py-3 px-5">
              <div class="flex items-center">
                <span class="count text-gray-600">20</span>
                <div class="flex flex-col leading-tight px-5">
                  <span class="text-blue-600 font-semibold text-sm">777 OG Eight</span>
                  <small class="text-gray-600">777-og-eighth</small>
                </div>
              </div>
              <a
                @click="openRemove()"
                class="text-gray-600 cursor-pointer"
                ><MinusCircleIcon
                  class="h-5 w-5 text-gray-600"
                  aria-hidden="true"
              /></a>
            </div>
            <!-- ITEM -->
          </div>
        </div>
      </div>
    </div>

    <template #modals>
      <confirm-danger
        title="Removing Item from Inventory Count"
        :show="showingConfirmRemoveModal"
        @close="showingConfirmRemoveModal = false"
        @confirm="showingConfirmRemoveModal = false"
      >
        <div class="mr-5">
          <b>Are you sure you want to remove 20 quantity of 777 OG Eight from inventory count?</b>
        </div>
      </confirm-danger>
    </template>
  </AdminLayout>
</template>
<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'
import DataTable from '@/Components/Table/CountDataTable'
import CountRow from '@/Pages/Counts/Components/CountRow'
import ConfirmDanger from '@/Components/Modals/ConfirmDanger'
import {
  CalendarIcon,
  ClockIcon,
  LocationMarkerIcon,
  SearchIcon,
  MinusCircleIcon,
  ExclamationCircleIcon,
  TagIcon
} from '@heroicons/vue/outline'

export default {
  components: {
    AdminLayout,
    Head,
    Link,
    CalendarIcon,
    ClockIcon,
    LocationMarkerIcon,
    SearchIcon,
    MinusCircleIcon,
    TagIcon,
    DataTable,
    CountRow,
    ExclamationCircleIcon,
    ConfirmDanger
  },

  mixins: [],

  props: {},

  data() {
    return {
      showingConfirmRemoveModal: false,
      selected: false,
      data: [{}]
    }
  },

  created() {},

  computed: {
    headers() {
      return ['Product', 'Count', 'Expected']
    }
  },

  methods: {
    openRemove() {
      this.showingConfirmRemoveModal = true
    },
    closeRemove() {
      this.showingConfirmRemoveModal = false
    }
  }
}
</script>

<style>
.select-table-container table thead tr th:nth-child(2) {
  width: 70%;
}

.select-table-container table thead tr th:nth-child(3),
.select-table-container table thead tr th:nth-child(4),
.select-table-container table tbody tr td:nth-child(3),
.select-table-container table tbody tr td:nth-child(4) {
  text-align: center;
}
</style>
